import React, { useState, useContext, useCallback, useMemo } from 'react';

import * as S from './QuestionnaireStyles';
import DisplayContext from '../../../UtilityComponents/displayContext';
import Button from '../../../common/Button/Button';
import { Card, GenericP } from '../../../common/Styles';
import Modal from '../../../common/Modal/Modal';
import BottomModal from '../../../common/BottomModal/BottomModal';
import GuidelinesFormDesktopModal from '../GuidelinesModal/GuidelinesFormDesktopModal';
import { getPrepGuidlinse } from '../../landingApi';
import landingContext from '../../landingContext';
import { ADOBE_EVENT_VALUES, APPLICATION_CONSTANTS, MODAL_NAMES } from '../../../AppConstants';
import { trackClickEvents } from '../../utils';

const QuestionnaireForm = ({ questions = [] }) => {
	const [count, setCount] = useState(0);

	const [answer, setAnswer] = useState({});

	const numberOfQuestions = questions.length;

	const handleQuesChange = useCallback((i) => () => {
		setCount((ct) => ct + i);
		let trackVal = ADOBE_EVENT_VALUES.LANDING?.PREVIOUS;
		if (i > 0) {
			trackVal = ADOBE_EVENT_VALUES.LANDING?.NEXT;
		}
		const eventIndex = count + 1;
		trackClickEvents(`${trackVal}_${eventIndex}_clicked`);
	}, [count]);

	if (questions.length === 0 ) {
		return null;
	}

	return (
		<Card boxPadding='20px'>
			<S.Progress que={count + 1} total={questions.length} />
			<GenericP fsize='16px' color='#3b385e' bottom_M='20' f_weight='bold'>
				{`Question ${count + 1}/${questions.length}`}
			</GenericP>
			<GenericP fsize='16px' color='#3b385e' bottom_M='16' f_weight='bold'>
				{`${questions[count] ? questions[count].question : ''}`}
			</GenericP>
			<CardOptions
				count={count}
				questions={questions}
				handleNext={handleQuesChange( 1)}
				handlePrevious={handleQuesChange(-1)}
				setAnswer={setAnswer}
				numberOfQuestions={numberOfQuestions}
			/>
		</Card>
	);
};

const CardOptions = ({
	count,
	questions,
	handleNext,
	handlePrevious,
	numberOfQuestions,
	handleModal
}) => {
	const [formData, setFormData] = useState({
		guidelines: [],
		userEmail: '',
		phoneNumber: ''
	});
	const appContext = useContext(landingContext) || {};
	const { bizModal, toggleModal } = appContext;
	const [status, setStatus] = useState('def');
	const [errorMsg, setErrorMsg] = useState();

	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = displayName == 'mobile';

	const Modaldata = useMemo(() => ({
		title: '',
		img: null,
		imgstyle: null,
		btnTxt: null,
		handleClick: handleModal
	}));

	const handleSubmit = useCallback(async (e) => {
		e.preventDefault();
		try {
			setStatus('preparing');
			const response = await getPrepGuidlinse(formData);
			if (response.data && response.data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
				window.open(response.data.pdfUrl);
				setStatus('downloaded');
			} else {
				setErrorMsg('Something went wrong, please try again later');
				setStatus('def');
			}
		} catch (error) {
			setErrorMsg('Something went wrong, please try again later');
			setStatus('def');
		}
		trackClickEvents(ADOBE_EVENT_VALUES.LANDING?.DOWNLOAD_NOW);
	}, [formData]);

	const setFormInputVals = useCallback((data = {}, que)=>{
		setFormData((fData) => {
			const { key, text } = data;
			fData.guidelines[count] = {
				'questionKey': que,
				'key': key,
				'text': text
			};
			return { ...fData };
		});
		const eventIndex = +count + 1;
		trackClickEvents(`${ADOBE_EVENT_VALUES.LANDING?.ANSWER}_${eventIndex}_clicked`);
	}, [count, formData]);

	const onInputChange = useCallback((key, val)=> {
		setFormData((fData) => {
			fData[key] = val;
			return { ...fData };
		});
	}, [formData]);

	const handleDownloadForm = useCallback(() => {
		toggleModal(bizModal === MODAL_NAMES.GUIDLINES ? false : MODAL_NAMES.GUIDLINES);
		setStatus('def');
		if (!bizModal) {
			trackClickEvents(ADOBE_EVENT_VALUES.LANDING?.DOWNLOAD_GUIDELINES);
		}
	}, [toggleModal, setStatus, bizModal]);
	const formInput = questions[count];
	return (
		<>
			<S.QuestionnaireList>
				{formInput && formInput.options.map((data, index) => (
					<li
						key={index}
						className={`${formData.guidelines[count] && formData.guidelines[count].key === data.key ? 'active' : ''}`}
						onClick={() => setFormInputVals(data, formInput.key)}>
						{data.text}
					</li>
				))}
			</S.QuestionnaireList>
			<S.BtnWrapper>
				{count > 0 ? (
					<Button
						btnTxt='Previous'
						btnType='Flat'
						btnName='Secondary'
						btnShadow
						btnWidth={`${isMobile ? '100%' : '23%'}`}
						disabled={false}
						height='44px'
						handleClick={handlePrevious}
					/>
				) : null}
				{(count !== numberOfQuestions - 1) ? (
					<Button
						btnTxt='NEXT'
						btnType='Flat'
						btnName='Secondary'
						btnShadow
						btnWidth={`${isMobile ? '100%' : '15%'}`}
						height='44px'
						handleClick={handleNext}
						disabled={formInput && !formData.guidelines[count]}
					/>
				) : (
					<Button
						btnTxt='Download Guidelines'
						btnType='Flat'
						btnName='Primary'
						btnShadow
						btnWidth={`${isMobile ? '100%' : '42%'}`}
						height='44px'
						handleClick={() => handleDownloadForm(true)}
						disabled={!formData.guidelines[numberOfQuestions - 1]}
					/>
				)}
			</S.BtnWrapper>
			{bizModal === MODAL_NAMES.GUIDLINES ? (
				isMobile ? (
					<BottomModal errorMsg={errorMsg} handleModal={handleDownloadForm}>
						<S.BottomModalInnerWrap>
							<GuidelinesFormDesktopModal status={status} onChangeInput={onInputChange} handleSubmit={handleSubmit} />
						</S.BottomModalInnerWrap>
					</BottomModal>
				) : (
					<Modal
						close
						errorMsg={errorMsg}
						Modaldata={Modaldata}
						$width='510px'
						style={{ height: '570px' }}
						handleModal={handleDownloadForm}>
						<GuidelinesFormDesktopModal status={status} onChangeInput={onInputChange} handleSubmit={handleSubmit} />
					</Modal>
				)
			) : null}
		</>
	);
};

export default QuestionnaireForm;
